// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../components/Form.bs.js";
import * as Liff from "../liff/Liff.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Fetch from "bs-fetch/src/Fetch.bs.js";
import * as Modal from "../components/Modal.bs.js";
import * as Title from "../components/Title.bs.js";
import * as Tools from "../Tools.bs.js";
import * as React from "react";
import * as Button from "../components/Button.bs.js";
import * as Config from "../Config.bs.js";
import * as Layout from "../Layout.bs.js";
import * as Loading from "../components/Loading.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as HookProfile from "../hooks/HookProfile.bs.js";
import * as ProfileForm from "./ProfileForm.bs.js";
import * as ProfileReducer from "./ProfileReducer.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function deleteProfile(token) {
  var requestInit = Fetch.RequestInit.make(/* Delete */4, {
          Authorization: "Bearer " + token
        }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return fetch(Config.url, requestInit).then(Tools.parseJsonIfOk);
}

function updateProfile(token, body) {
  var requestInit = Fetch.RequestInit.make(/* Put */3, {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json; charset=UTF-8"
        }, Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return fetch(Config.url, requestInit).then(Tools.parseJsonIfOk);
}

function ProfileEditPage$WithHookProfileEditPage(Props) {
  var profile = Props.profile;
  var token = Props.token;
  var loading = React.useRef(false);
  var match = React.useState(function () {
        
      });
  var setValidatedState = match[1];
  var validated_state = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setInitProfile = match$1[1];
  var init_profile = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setActiveModal = match$2[1];
  React.useEffect((function () {
          var p = ProfileReducer.checkHookProfile(profile);
          if (p.TAG === /* Ok */0) {
            var p$1 = p._0;
            Curry._1(setInitProfile, (function (param) {
                    return p$1;
                  }));
          }
          
        }), [profile]);
  var handleDelete = function (param) {
    if (!loading.current) {
      loading.current = true;
      Curry._1(setActiveModal, (function (param) {
              return false;
            }));
      deleteProfile(token).then(function (resp) {
            var tmp;
            tmp = resp.TAG === /* Ok */0 ? RescriptReactRouter.push("/delete/success") : RescriptReactRouter.push("/error");
            return Promise.resolve(tmp);
          });
      return ;
    }
    
  };
  var handleUpdate = function (param) {
    if (loading.current) {
      return ;
    }
    loading.current = true;
    if (validated_state === undefined) {
      return ;
    }
    var body = JSON.stringify(ProfileReducer.toJson(validated_state, "_updated"));
    updateProfile(token, body).then(function (resp) {
          var tmp;
          tmp = resp.TAG === /* Ok */0 ? RescriptReactRouter.push("/edit/success") : RescriptReactRouter.push("/error");
          return Promise.resolve(tmp);
        });
    
  };
  if (loading.current) {
    return React.createElement(Layout.Loading.make, {});
  } else {
    return React.createElement(Layout.Default.make, {
                children: null,
                hero: true
              }, init_profile !== undefined ? React.createElement(ProfileForm.make, {
                      init_profile: init_profile,
                      onValidateForm: setValidatedState,
                      is_edited: true,
                      key: "1"
                    }) : React.createElement(ProfileForm.make, {
                      init_profile: ProfileReducer.initial_state,
                      onValidateForm: setValidatedState,
                      is_edited: true,
                      key: "2"
                    }), React.createElement(Form.GroupInput.make, {
                    children: React.createElement(Button.make, {
                          label: "ยืนยัน",
                          disabled: Belt_Option.isNone(validated_state),
                          onClick: handleUpdate
                        })
                  }), React.createElement(Form.GroupInput.make, {
                    children: React.createElement(Button.Outline.make, {
                          label: "ลบข้อมูล",
                          onClick: (function (param) {
                              return Curry._1(setActiveModal, (function (param) {
                                            return true;
                                          }));
                            })
                        })
                  }), React.createElement(Modal.make, {
                    children: null,
                    hidden: !match$2[0],
                    onClose: (function (param) {
                        
                      })
                  }, React.createElement(Title.make, {
                        text: "ยืนยันการลบข้อมูล",
                        ext_class: "justify-center"
                      }), React.createElement("div", {
                        className: "text-label px-7 text-center pb-4"
                      }, "หากคุณยืนยันการลบข้อมูล คะแนนสะสมและเหรียญรางวัลทั้งหมดจะหายไป โดยไม่สามารถกู้คืนบัญชีได้"), React.createElement(Form.GroupInput.make, {
                        children: React.createElement(Button.make, {
                              label: "ยืนยัน",
                              disabled: Belt_Option.isNone(validated_state),
                              onClick: handleDelete
                            })
                      }), React.createElement(Form.GroupInput.make, {
                        children: React.createElement(Button.Outline.make, {
                              label: "ยกเลิก",
                              onClick: (function (param) {
                                  return Curry._1(setActiveModal, (function (param) {
                                                return false;
                                              }));
                                })
                            })
                      })));
  }
}

var WithHookProfileEditPage = {
  make: ProfileEditPage$WithHookProfileEditPage
};

function ProfileEditPage(Props) {
  var liff = React.useContext(Liff.context);
  var token = liff.access_token;
  var state = HookProfile.useProfile(token);
  if (typeof state === "number") {
    if (state === /* Request */0) {
      return React.createElement(Layout.Default.make, {
                  children: React.createElement("div", {
                        className: ""
                      }, React.createElement(Loading.make, {}))
                });
    } else {
      return React.createElement(Layout.$$Error.make, {});
    }
  } else if (state.TAG === /* SuccessRegisterdProfile */1) {
    return React.createElement(ProfileEditPage$WithHookProfileEditPage, {
                profile: state._0,
                token: token
              });
  } else {
    return React.createElement(Layout.$$Error.make, {});
  }
}

var make = ProfileEditPage;

export {
  deleteProfile ,
  updateProfile ,
  WithHookProfileEditPage ,
  make ,
  
}
/* Form Not a pure module */
